import { FC } from "react"
import { selectOrdersStore } from "../../app/reducers/ordersReducer"
import { useAppSelector } from "../../app/hooks"
import { Tabs } from "../Tabs/Tabs"
import { useNavigateSubTab } from "../../utils/hooks/useNavigateTab"
import { TabContent } from "../Tab/TabContent"
import { WBNewOrders } from "./wb/WBNewOrders"
import { OzonNewOrders } from "./ozon/OzonNewOrders"
import {
  selectActiveShops,
  SHOP_IDENT,
} from "../../app/reducers/settingsReducer"
import { WBTokenGuard } from "../WBTokenGuard/WBTokenGuard"

export const NewOrders: FC = () => {
  const ordersStore = useAppSelector(selectOrdersStore)
  const {
    orders,
    storages,
    supplies,
    lastDateUpdatedSupplies,
    ozonStorages,
    ozonOrders,
  } = ordersStore
  const [activeSubTab, navigate] = useNavigateSubTab()
  const activeShops = useAppSelector(selectActiveShops)
  return (
    <Tabs onChange={navigate} activeTabIdent={activeSubTab}>
      <TabContent name="Wildberries" ident={"wildberries"}>
        <WBTokenGuard>
          <WBNewOrders
            orders={orders}
            storages={storages}
            supplies={supplies}
            lastDateUpdatedSupplies={lastDateUpdatedSupplies}
          />
        </WBTokenGuard>
      </TabContent>
      {activeShops.includes(SHOP_IDENT.KATREN_OZON) && (
        <TabContent name="OZON" ident={"ozon"}>
          <OzonNewOrders orders={ozonOrders} storages={ozonStorages} />
        </TabContent>
      )}
    </Tabs>
  )
}
